export const closeSchoolData = [
  {
    key: '1',
    col1: '41',
    col2: '인천학익풍림점',
    col3: 'st_123',
    col4: '010-1111-2222',
    col5: '김큐미르',
    col6: '1',
    col7: '1',
    col8: '건의건의',
    col9: '1'
  },
  {
    key: '1',
    col1: '42',
    col2: '청주용암대원2단지점',
    col3: 'st_456',
    col4: '010-3333-4444',
    col5: '선우아솝이',
    col6: '0',
    col7: '0',
    col8: '거니거니',
    col9: '0'
  },
  {
    key: '1',
    col1: '43',
    col2: '청주 밥서두진점',
    col3: 'st_789',
    col4: '010-5555-6666',
    col5: '박큐미르',
    col6: '1',
    col7: '0',
    col8: '으이으이',
    col9: '0'
  }
];

export const closeSchoolDetailData1 = [
  {
    key: '1',
    col1: '입회',
    col2: '신규',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '0'
  },
  {
    key: '2',
    col1: '',
    col2: '재입회',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: ''
  },
  {
    key: '3',
    col1: '휴회',
    col2: '',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: ''
  },
  {
    key: '4',
    col1: '순증',
    col2: '',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: ''
  }
];
export const closeSchoolDetailData2 = [
  {
    key: '1',
    col1: '1주',
    col2: 'eee',
    col3: '',
    col4: '0',
    col5: '0'
  },
  {
    key: '2',
    col1: '2주',
    col2: 'rrr',
    col3: '',
    col4: '0',
    col5: '0'
  },
  {
    key: '3',
    col1: '3주',
    col2: 'qq',
    col3: '',
    col4: '0',
    col5: '0'
  },
  {
    key: '4',
    col1: '4주',
    col2: 'wer',
    col3: '',
    col4: '0',
    col5: '0'
  },
  {
    key: '5',
    col1: '5주',
    col2: 'zcxv',
    col3: '',
    col4: '0',
    col5: '0'
  },
  {
    key: '6',
    col1: '카페활동 (월 게시글 4개 기준)',
    col2: '게시글( 0 )회, 덧글 ( 0 )회',
    col3: '합계',
    col4: '0',
    col5: '0'
  }
];
export const closeSchoolDetailData3 = [
  {
    key: '1',
    col1: '1',
    col2: '테1',
    col3: '',
    col4: '',
    col5: ''
  },
  {
    key: '2',
    col1: '2',
    col2: '테2',
    col3: '',
    col4: '',
    col5: ''
  },
  {
    key: '3',
    col1: '3',
    col2: '테3',
    col3: '',
    col4: '',
    col5: ''
  }
];

export const closeBranchData1 = [
  {
    key: '1',
    col1: '2',
    col2: '2',
    col3: '1',
    col4: '0',
    col5: '0',
    col6: '0'
  }
];
export const closeBranchData2 = [
  {
    key: '1',
    col1: '0',
    col2: '0',
    col3: '0',
    col4: '0',
    col5: '0',
    col6: '0'
  }
];

export const closeBranchPerformanceReportData = [
  {
    key: '1',
    col1: '본사직영',
    col2: '1월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '2',
    col1: '본사직영',
    col2: '2월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '3',
    col1: '본사직영',
    col2: '3월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '4',
    col1: '본사직영',
    col2: '4월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '5',
    col1: '본사직영',
    col2: '5월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '6',
    col1: '본사직영',
    col2: '6월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '7',
    col1: '본사직영',
    col2: '7월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '8',
    col1: '본사직영',
    col2: '8월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '9',
    col1: '본사직영',
    col2: '9월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '10',
    col1: '본사직영',
    col2: '10월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '11',
    col1: '본사직영',
    col2: '11월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  },
  {
    key: '12',
    col1: '본사직영',
    col2: '12월',
    col3: '',
    col4: '',
    col5: '',
    col6: '',
    col7: '',
    col8: '',
    col9: '',
    col10: '',
    col11: '',
    col12: '',
    col13: '',
    col14: ''
  }
];
export const closeBranchReportData = [];

export const closeBranchDetailListData = [
  {
    key: 'FRCS1',
    col1: '가맹상담',
    col2: '상담건수',
    col3: '',
    mon1: '1', //1월의 상담건수
    mon2: '1', //2월의 상담건수
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'FRCS2',
    col1: '',
    col2: '계약가능상담자',
    col3: '',
    mon1: '2', //1월의 계약가능상담자
    mon2: '2', //2월의 계약가능상담자
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'FRCT1',
    col1: '가맹계약',
    col2: '계약건',
    col3: '',
    mon1: '3',
    mon2: '3',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'FRCT2',
    col1: '',
    col2: '교육원',
    col3: '',
    mon1: '4',
    mon2: '4',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CTCC1',
    col1: '계약해지',
    col2: '해지건',
    col3: '',
    mon1: '5',
    mon2: '5',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CTCC2',
    col1: '',
    col2: '교육원',
    col3: '',
    mon1: '6',
    mon2: '6',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CTCC3',
    col1: '',
    col2: '해지사유',
    col3: '',
    mon1: '해지사유1',
    mon2: '해지사유2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'NESC1',
    col1: '신규교육원',
    col2: '가맹교육 대상',
    col3: '',
    mon1: '8',
    mon2: '8',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'NESC2',
    col1: '',
    col2: '정착교육 대상',
    col3: '',
    mon1: '9',
    mon2: '9',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'NESC3',
    col1: '',
    col2: '정착교육 관리 내용',
    col3: '',
    mon1: '관리내용1',
    mon2: '관리내용2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN1',
    col1: '교육원 관리',
    col2: '방문횟수',
    col3: '',
    mon1: '11',
    mon2: '11',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN2',
    col1: '',
    col2: '운영팀 방문요청 교육원',
    col3: '',
    mon1: '12',
    mon2: '12',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN3',
    col1: '',
    col2: '요청 사유',
    col3: '',
    mon1: '요청사유1',
    mon2: '요청사유2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN4',
    col1: '',
    col2: '문제교육원',
    col3: '',
    mon1: '14',
    mon2: '14',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN5',
    col1: '',
    col2: '문제사항',
    col3: '',
    mon1: '문제사항1',
    mon2: '문제사항2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'SCMN6',
    col1: '',
    col2: '관리방안',
    col3: '',
    mon1: '관리방안1',
    mon2: '관리방안2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CSMN1',
    col1: '상담관리',
    col2: '정기상담 관리를 위한 활동',
    col3: '',
    mon1: '17',
    mon2: '17',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CSMN2',
    col1: '',
    col2: '가정통신문 미발송 교육원',
    col3: '',
    mon1: '18',
    mon2: '18',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'CSMN3',
    col1: '',
    col2: '미발송 사유',
    col3: '',
    mon1: '미발송사유1',
    mon2: '미발송사유2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'COSM',
    col1: '홍보,광고비용 합계',
    col2: '',
    col3: '',
    mon1: '5000',
    mon2: '2000',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK1',
    col1: '온라인 홍보',
    col2: '맘카페',
    col3: '횟수/비용',
    mon1: '10000',
    mon2: '30000',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK2',
    col1: '',
    col2: '',
    col3: 'url_1',
    mon1: 'https://www.naver.com',
    mon2: 'https://www.naver.com',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK3',
    col1: '',
    col2: '',
    col3: 'url_2',
    mon1: 'https://www.naver.com',
    mon2: 'https://www.naver.com',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK4',
    col1: '',
    col2: '',
    col3: 'url_3',
    mon1: 'https://www.naver.com',
    mon2: 'https://www.naver.com',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK5',
    col1: '',
    col2: '',
    col3: 'url_4',
    mon1: '',
    mon2: '',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK6',
    col1: '',
    col2: '공식카페',
    col3: '창업(횟수)',
    mon1: '26',
    mon2: '26',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK7',
    col1: '',
    col2: '',
    col3: '입회(횟수)',
    mon1: '27',
    mon2: '27',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK8',
    col1: '',
    col2: '블로그',
    col3: '창업(횟수)',
    mon1: '28',
    mon2: '28',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK9',
    col1: '',
    col2: '',
    col3: '입회(횟수)',
    mon1: '29',
    mon2: '29',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK10',
    col1: '',
    col2: '',
    col3: '기타내용(횟수)',
    mon1: '30',
    mon2: '30',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK11',
    col1: '',
    col2: '인스타그램',
    col3: '광고여부/비용',
    mon1: '10000',
    mon2: '25000',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK12',
    col1: '',
    col2: '',
    col3: '창업(횟수)',
    mon1: '32',
    mon2: '32',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK13',
    col1: '',
    col2: '',
    col3: '입회(횟수)',
    mon1: '33',
    mon2: '33',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK14',
    col1: '',
    col2: '',
    col3: '기타내용(횟수)',
    mon1: '34',
    mon2: '34',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK15',
    col1: '',
    col2: '기타',
    col3: '횟수/비용',
    mon1: '10000',
    mon2: '5000',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK16',
    col1: '',
    col2: '',
    col3: 'URL',
    mon1: 'https://www.naver.com',
    mon2: 'https://www.naver.com',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ONMK17',
    col1: '',
    col2: '',
    col3: '홍보 내용',
    mon1: '홍보내용1',
    mon2: '홍보내용2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'OFMK1',
    col1: '오프라인 홍보',
    col2: '횟수/비용',
    col3: '',
    mon1: '30000',
    mon2: '13000',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'OFMK2',
    col1: '',
    col2: '활동내용',
    col3: '',
    mon1: '활동내용1',
    mon2: '활동내용2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'OFMK3',
    col1: '',
    col2: '활동사진',
    col3: '',
    mon1: '사진1',
    mon2: '사진2',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'MNME1',
    col1: '월간회의',
    col2: '관리교육원',
    col3: '',
    mon1: '41',
    mon2: '41',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'MNME2',
    col1: '',
    col2: '참석교육원',
    col3: '',
    mon1: '42',
    mon2: '42',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'MNME3',
    col1: '',
    col2: '불참교육원&사유',
    col3: '',
    mon1: '43',
    mon2: '43',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'MNME4',
    col1: '',
    col2: '회의 내용',
    col3: '',
    mon1: '44',
    mon2: '44',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'MNME5',
    col1: '',
    col2: '학원 강사 스터디',
    col3: '',
    mon1: '45',
    mon2: '45',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  },
  {
    key: 'ETC',
    col1: '건의사항 & 아이디어',
    col2: '',
    col3: '',
    mon1: '건의사항1',
    mon2: '아이디어1',
    mon3: '',
    mon4: '',
    mon5: '',
    mon6: '',
    mon7: '',
    mon8: '',
    mon9: '',
    mon10: '',
    mon11: '',
    mon12: ''
  }
];

export const closeDetailData1 = [
  {
    key: '1',
    col1: '가맹해지 관리',
    col2: '가맹문의자관리',
    col3: '일시',
    col4: '123'
  },
  {
    key: '2',
    col1: '',
    col2: '',
    col3: '활동내용',
    col4: 'qwre'
  },
  {
    key: '3',
    col1: '',
    col2: '가맹계약 프로모션',
    col3: '대상',
    col4: ''
  },
  {
    key: '4',
    col1: '',
    col2: '',
    col3: '내용',
    col4: ''
  },
  {
    key: '5',
    col1: '',
    col2: '사업설명회(월 1회)',
    col3: '일시',
    col4: ''
  },
  {
    key: '6',
    col1: '',
    col2: '',
    col3: '장소',
    col4: ''
  },
  {
    key: '7',
    col1: '',
    col2: '가맹해지 관리',
    col3: '대상',
    col4: ''
  },
  {
    key: '8',
    col1: '',
    col2: '',
    col3: '내용',
    col4: ''
  }
];
export const closeDetailData2 = [
  {
    key: '1',
    col1: '가맹해지 관리',
    col2: '유입 전략 활동',
    col3: '신규입회',
    col4: ''
  },
  {
    key: '2',
    col1: '',
    col2: '',
    col3: '재입회',
    col4: ''
  },
  {
    key: '3',
    col1: '',
    col2: '휴회 관리 활동',
    col3: '대상',
    col4: ''
  },
  {
    key: '4',
    col1: '',
    col2: '',
    col3: '내용',
    col4: ''
  },
  {
    key: '5',
    col1: '',
    col2: '[추가활동]',
    col3: '',
    col4: ''
  }
];
export const closeDetailData3 = [
  {
    key: '1',
    col1: '온라인 홍보',
    col2: '네이버 큐미르 공식카페 글쓰기(주 2회)',
    col3: '',
    col4: ''
  },
  {
    key: '2',
    col1: '',
    col2: '블로그 활동',
    col3: '',
    col4: ''
  },
  {
    key: '3',
    col1: '',
    col2: '성공운 활동',
    col3: '',
    col4: ''
  },
  {
    key: '4',
    col1: '',
    col2: '지역맘카페 입점',
    col3: '카페명',
    col4: ''
  },
  {
    key: '5',
    col1: '',
    col2: '',
    col3: '활동내용',
    col4: ''
  },
  {
    key: '6',
    col1: '',
    col2: '',
    col3: '등록횟수',
    col4: ''
  },
  {
    key: '7',
    col1: '',
    col2: '알바천국',
    col3: '등록횟수',
    col4: ''
  },
  {
    key: '8',
    col1: '',
    col2: '',
    col3: '등록(업데이트)일',
    col4: ''
  },
  {
    key: '9',
    col1: '',
    col2: '[추가활동]',
    col3: '',
    col4: ''
  },
  {
    key: '10',
    col1: '오프라인 홍보',
    col2: '옥외광고(간접 설치물 광고)',
    col3: '',
    col4: ''
  },
  {
    key: '11',
    col1: '',
    col2: '직투광고(직접 전달 홍보)',
    col3: '',
    col4: ''
  },
  {
    key: '12',
    col1: '',
    col2: '[추가활동]',
    col3: '',
    col4: ''
  }
];

export const closeDetailData4 = [
  {
    key: '1',
    col1: '교육',
    col2: '신규 가맹교육',
    col3: '교육원명(회차)',
    col4: ''
  },
  {
    key: '2',
    col1: '',
    col2: '',
    col3: '원장님 특징 및 교육반응',
    col4: ''
  },
  {
    key: '3',
    col1: '',
    col2: '',
    col3: '교육시 필요한 부분',
    col4: ''
  },
  {
    key: '4',
    col1: '',
    col2: '재교육',
    col3: '일시',
    col4: ''
  },
  {
    key: '5',
    col1: '',
    col2: '',
    col3: '교육주제',
    col4: ''
  },
  {
    key: '6',
    col1: '',
    col2: '',
    col3: '참여대상',
    col4: ''
  },
  {
    key: '7',
    col1: '',
    col2: '[추가활동]',
    col3: '',
    col4: ''
  }
];

export const closeDetailData5 = [
  {
    key: '1',
    col1: '월례모임',
    col2: '일자',
    col3: '일자1',
    col4: ''
  },
  {
    key: '2',
    col1: '',
    col2: '',
    col3: '일자2',
    col4: ''
  },
  {
    key: '3',
    col1: '',
    col2: '',
    col3: '일자3',
    col4: ''
  },
  {
    key: '4',
    col1: '',
    col2: '',
    col3: '일자4',
    col4: ''
  },
  {
    key: '5',
    col1: '',
    col2: '',
    col3: '일자5',
    col4: ''
  },
  {
    key: '6',
    col1: '',
    col2: '장소',
    col3: '',
    col4: ''
  },
  {
    key: '7',
    col1: '',
    col2: '불참교육원',
    col3: '',
    col4: ''
  },
  {
    key: '8',
    col1: '',
    col2: '',
    col3: '',
    col4: ''
  },
  {
    key: '9',
    col1: '',
    col2: '회의록',
    col3: '',
    col4: ''
  },
  {
    key: '10',
    col1: '',
    col2: '',
    col3: '',
    col4: ''
  },
  {
    key: '11',
    col1: '',
    col2: '스터디',
    col3: '주제',
    col4: ''
  },
  {
    key: '12',
    col1: '',
    col2: '',
    col3: '방식',
    col4: ''
  },
  {
    key: '13',
    col1: '',
    col2: '',
    col3: '결과물',
    col4: ''
  },
  {
    key: '14',
    col1: '건의사항',
    col2: '',
    col3: '',
    col4: 'dfsafda'
  }
];
